import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 25"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M22.95 14.6a.75.75 0 0 1-1.05-.15A4.84 4.84 0 0 0 18 12.5a.75.75 0 1 1 0-1.5 2.25 2.25 0 1 0-2.179-2.812.751.751 0 0 1-1.453-.375 3.75 3.75 0 1 1 6.163 3.704 6.37 6.37 0 0 1 2.572 2.032.75.75 0 0 1-.153 1.051m-5.051 5.775a.75.75 0 1 1-1.298.75 5.345 5.345 0 0 0-9.202 0 .751.751 0 1 1-1.298-.75 6.76 6.76 0 0 1 3.163-2.805 4.5 4.5 0 1 1 5.472 0 6.76 6.76 0 0 1 3.163 2.805M12 17a3 3 0 1 0 0-6 3 3 0 0 0 0 6m-5.25-5.25A.75.75 0 0 0 6 11a2.25 2.25 0 1 1 2.179-2.812.75.75 0 0 0 1.453-.375 3.75 3.75 0 1 0-6.163 3.704A6.37 6.37 0 0 0 .9 13.549a.75.75 0 0 0 1.2.901A4.84 4.84 0 0 1 6 12.5a.75.75 0 0 0 .75-.75"
    }, null, -1)
  ])))
}
export default { render: render }